import { useMemo } from 'react'
import useNow from 'src/utils/hooks/useNow'

export function useCountdownTimer(deltaMs: number) {
  const targetTimestamp = useMemo(() => Date.now() + deltaMs, [deltaMs])
  const now = useNow()

  return useMemo(() => {
    const timeLeft = targetTimestamp - now
    // Ignore any value < 1000
    return timeLeft < 1000 ? 0 : timeLeft
  }, [now, targetTimestamp])
}
